import { useCallback } from 'react';
import { useCompanyDomainsSearchListLazyQuery } from 'graphql-common';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getCompanyDomainsLoadOptions } from 'utils/fetch/searchLists/companyDomainsSearchList';

export default function useCompanyDomainsOptions() {
  const [fetchCompanyDomains] = useCompanyDomainsSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });

  const companyDomainsLoadOptions: GetLoadOptions = useCallback(
    () => getCompanyDomainsLoadOptions(fetchCompanyDomains),
    [fetchCompanyDomains],
  );

  return { companyDomainsLoadOptions };
}
